import { useTheme } from "styled-components";

import { useIsPtOoo } from "contexts/ProfileContext";
import { NAVBAR_HEIGHT } from "shared/NavBar";

export const usePageContentOffsetTop = (): number => {
  const theme = useTheme();
  const { isPtOoo } = useIsPtOoo();

  if (window.innerWidth > parseInt(theme.breakpoint, 10)) {
    return 0;
  }

  return isPtOoo ? 0 : NAVBAR_HEIGHT;
};
